import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { layout: 'none', requiresAuth: false },
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/article',
    name: 'article',
    meta: { layout: 'default', requiresAuth: true },
    component: () => import('../views/Article.vue'),
  },
  {
    path: '/post/:id',
    name: 'post',
    meta: { layout: 'default', requiresAuth: true },
    props: true,
    component: () => import('../views/Post.vue'),
  },
  {
    path: '/post',
    name: 'post_new',
    meta: { layout: 'default', requiresAuth: true },
    props: true,
    component: () => import('../views/Post.vue'),
  },
  {
    path: '/preview',
    name: 'preview',
    meta: { layout: 'public', requiresAuth: true },
    props: true,
    component: () => import('../views/Preview.vue'),
  },
  {
    path: '/media',
    name: 'media',
    meta: { layout: 'default', requiresAuth: true },
    props: true,
    component: () => import('../views/Media.vue'),
  },
  {
    path: '/category',
    name: 'category',
    meta: { layout: 'default', requiresAuth: true },
    props: true,
    component: () => import('../views/Category.vue'),
  },
  {
    path: '/tag',
    name: 'tag',
    meta: { layout: 'default', requiresAuth: true },
    props: true,
    component: () => import('../views/Tag.vue'),
  },
  {
    path: '/user',
    name: 'user',
    meta: { layout: 'default', requiresAuth: true },
    props: true,
    component: () => import('../views/User.vue'),
  },
  {
    path: '/ping',
    name: 'ping',
    meta: { layout: 'none', requiresAuth: false },
    props: true,
    component: () => import('../views/Ping.vue'),
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
})

router.beforeEach((to, from, next) => {
  const toRequiresAuthPage = to.matched.some(record => record.meta.requiresAuth)
  const loggedIn = window.$cookies.isKey('user_name') && window.$cookies.isKey('token')

  const toLoginPage = to.name === 'Home'

  if(toRequiresAuthPage) {
    if (loggedIn) {
      next()
    } else {
      localStorage.clear() // 記事プレビューデータの流出防止

      next({ name: 'Home' });
    }
  } else {
    if (loggedIn) {
      if (toLoginPage) {
        next({ name: 'article' });
      } else {
        next()
      }
    } else {
      localStorage.clear() // 記事プレビューデータの流出防止

      next()
    }
  }
})

export default router
